import React, { FC } from "react";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";

interface UploadCertificateConfirmCardCard {
    handleCancel: () => void;
    handleConfirm: () => void;
    isEc3Controller: boolean;
}

const UploadCertificateConfirmCard: FC<UploadCertificateConfirmCardCard> = ({ handleCancel, handleConfirm, isEc3Controller }) => {
    const { translate } = useLocale();
    const translateKey = isEc3Controller ? TranslationKeys.sendCertificateToEc3ControllerMessage : TranslationKeys.sendCertificateToControllerMessage;

    return <div className="flex flex-col space-y-2 h-100 p-6" style={{ width: '600px'}}>
        <h4 className="font-bold">{translate.byKey(TranslationKeys.warning)}:</h4>
        <div style={{ maxWidth: '90%' }}>{translate.byKey(translateKey)}</div>
        <div className="flex flex-row space-x-2 justify-end bottom-0 right-0 mt-4">
            <button className="py-1 px-5 secondary secondary-enabled" type="button" onClick={handleConfirm}>
                {translate.byKey(TranslationKeys.confirm)}
            </button>
            <button className="py-1 px-5 font-bold" type="button" onClick={handleCancel}>
                {translate.byKey(TranslationKeys.cancel)}
            </button>
        </div>
    </div>
}

export default UploadCertificateConfirmCard;
